import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';
import { CardStyled } from 'v3/shared/components/WarningCard/styles';
import { WarningCardProps } from 'v3/shared/components/WarningCard/types';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';

export const WarningCard: React.FC<WarningCardProps> = ({ icon = <ErrorOutlineIcon />, message, backgroundColor }) => {
  return (
    <CardStyled style={{ backgroundColor: backgroundColor }}>
      {icon}
      <SubtitleMedium>{message}</SubtitleMedium>
    </CardStyled>
  );
};
